<template>
  <!-- <div class="alert bg-secondary-transparent alert-dismissible fade show mb-4">
    Your Leave Request on“24th April 2024”has been Approved!!!
    <button
      type="button"
      class="btn-close fs-14"
      data-bs-dismiss="alert"
      aria-label="Close"
    >
      <i class="ti ti-x"></i>
    </button>
  </div> -->
  <div class="row">
    <!-- LEFT: Employee profile summary -->
    <div :class="[profileColClass, 'd-flex']">
      <div class="card position-relative flex-fill">
        <div class="card-header bg-dark">
          <div class="d-flex align-items-center">
            <span
              class="avatar avatar-lg avatar-rounded border border-white border-2 flex-shrink-0 me-2"
            >
              <img :src="avatar" alt="Employee photo" />
            </span>
            <div>
              <h5 class="text-white mb-1">
                {{ fullName || "Employee" }}
              </h5>
              <div class="d-flex align-items-center flex-wrap">
                <p class="text-white fs-12 mb-0">
                  {{ designation || "Employee" }}
                </p>
                <span v-if="department" class="mx-1">
                  <i class="ti ti-point-filled text-primary"></i>
                </span>
                <p v-if="department" class="fs-12 mb-0">
                  {{ department }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body">
          <div class="mb-3">
            <span class="d-block mb-1 fs-13">Phone Number</span>
            <p class="text-gray-9">
              {{ phone || "Not set" }}
            </p>
          </div>
          <div class="mb-3">
            <span class="d-block mb-1 fs-13">Email Address</span>
            <p class="text-gray-9">
              {{ email || "Not set" }}
            </p>
          </div>
          <div class="mb-3" v-if="managerName">
            <span class="d-block mb-1 fs-13">Report To</span>
            <p class="text-gray-9">
              {{ managerName || "N/A" }}
            </p>
          </div>
          <div>
            <span class="d-block mb-1 fs-13">Joined on</span>
            <p class="text-gray-9">
              {{ joinedOn || "N/A" }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- MIDDLE: Attendance / Leave behaviour + donut chart -->
    <div v-if="showOverviewCard" :class="[overviewColClass, 'd-flex']">
      <div class="card flex-fill">
        <div class="card-header">
          <div
            class="d-flex align-items-center justify-content-between flex-wrap row-gap-2"
          >
            <h5>Leave & Attendance Overview</h5>
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="btn btn-white border btn-sm d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-calendar me-1"></i>{{ selectedYear }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li v-for="year in years" :key="year">
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="changeYear(year)"
                  >
                    {{ year }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="card-body">
          <div class="row align-items-center">
            <!-- Left: behaviour counters -->
            <div v-if="showAttendanceSection" class="col-md-6">
              <div class="mb-3">
                <p class="d-flex align-items-center mb-2">
                  <i class="ti ti-circle-filled fs-8 text-dark me-1"></i>
                  <span class="text-gray-9 fw-semibold me-1">
                    {{ onTimeDays }}
                  </span>
                  On time
                </p>
              </div>
              <div class="mb-3">
                <p class="d-flex align-items-center mb-2">
                  <i class="ti ti-circle-filled fs-8 text-success me-1"></i>
                  <span class="text-gray-9 fw-semibold me-1">
                    {{ lateDays }}
                  </span>
                  Late Attendance
                </p>
              </div>
              <div class="mb-3">
                <p class="d-flex align-items-center mb-2">
                  <i class="ti ti-circle-filled fs-8 text-primary me-1"></i>
                  <span class="text-gray-9 fw-semibold me-1">
                    {{ wfhDays }}
                  </span>
                  Work From Home
                </p>
              </div>
              <div class="mb-3">
                <p class="d-flex align-items-center mb-2">
                  <i class="ti ti-circle-filled fs-8 text-danger me-1"></i>
                  <span class="text-gray-9 fw-semibold me-1">
                    {{ absentDays }}
                  </span>
                  Absent
                </p>
              </div>
              <div>
                <p class="d-flex align-items-center mb-0">
                  <i class="ti ti-circle-filled fs-8 text-warning me-1"></i>
                  <span class="text-gray-9 fw-semibold me-1">
                    {{ sickLeaveDays }}
                  </span>
                  Sick Leave (booked)
                </p>
              </div>
            </div>

            <!-- Right: donut chart -->
            <div v-if="showLeaveSection" class="col-md-6">
              <div class="mb-3 d-flex justify-content-md-end">
                <div id="leaves_chart" class="w-100">
                  <apexchart
                    type="donut"
                    height="200"
                    :options="leaveChartOptions"
                    :series="leaveChartSeries"
                  />
                </div>
              </div>
            </div>

            <!-- Bottom: relative performance -->
            <!-- <div class="col-md-12">
              <div class="form-check mt-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="todo1"
                  checked
                  disabled
                />
                <label class="form-check-label" for="todo1">
                  Better than
                  <span class="text-gray-9"> {{ betterThanPercent }}% </span>
                  of Employees
                </label>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- RIGHT: Leave details for selected year -->
    <div v-if="showLeaveSection" class="col-xl-3 d-flex">
      <div class="card flex-fill">
        <div class="card-header">
          <div
            class="d-flex align-items-center justify-content-between flex-wrap row-gap-2"
          >
            <h5>Leave Details</h5>
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="btn btn-white border btn-sm d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-calendar me-1"></i>{{ selectedYear }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li v-for="year in years" :key="year">
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="changeYear(year)"
                  >
                    {{ year }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="card-body">
          <div class="row align-items-center">
            <div class="col-sm-6">
              <div class="mb-4">
                <span class="d-block mb-1">Total Leaves (Booked)</span>
                <h4>{{ totalLeaves }}</h4>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="mb-4">
                <span class="d-block mb-1">Taken (Approved)</span>
                <h4>{{ takenLeaves }}</h4>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="mb-4">
                <span class="d-block mb-1">Absent</span>
                <h4>{{ absentDays }}</h4>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="mb-4">
                <span class="d-block mb-1">Requests (New/Pending)</span>
                <h4>{{ requestedLeaves }}</h4>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="mb-4">
                <span class="d-block mb-1">Remaining (all types)</span>
                <h4 class="text-success">{{ remainingLeaves }}</h4>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="mb-4">
                <span class="d-block mb-1">Worked Days (This Month)</span>
                <h4>{{ workedDays }}</h4>
              </div>
            </div>
            <!-- <div class="col-sm-6">
              <div class="mb-4">
                <span class="d-block mb-1">Loss of Pay</span>
                <h4>{{ lossOfPay }}</h4>
              </div>
            </div> -->

            <div v-if="canApplyLeave" class="col-sm-12">
              <div>
                <a
                  data-bs-toggle="modal"
                  data-bs-target="#add_leaves"
                  class="btn btn-dark w-100"
                >
                  Apply New Leave
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <leaves-employee-modal v-if="canApplyLeave" />
</template>
<script setup>
import { computed, onMounted, ref } from "vue";
import { useAuthStore } from "@/stores/authStore";
import { useEmployeeLeaveStore } from "@/stores/employeeLeaveStore";
import { useAttendanceEmployeeStore } from "@/stores/attendanceEmployeeStore";
import LeavesEmployeeModal from "@/components/modal/leaves-employee-modal.vue";
import { resolveAvatarUrl } from "@/utils/imageHelpers";

// --- Stores ---
const authStore = useAuthStore();
const leaveStore = useEmployeeLeaveStore();
const attendanceStore = useAttendanceEmployeeStore();

function hasPermission(permission) {
  if (!permission) return false;
  return typeof authStore.can === "function" ? authStore.can(permission) : false;
}

const showLeaveSection = computed(
  () => hasPermission("Leaves.Read") || hasPermission("Leaves.Create"),
);

const canApplyLeave = computed(() => hasPermission("Leaves.Create"));

const showAttendanceSection = computed(
  () =>
    hasPermission("Attendance.Read") || hasPermission("Attendance.Create"),
);

const showOverviewCard = computed(
  () => showLeaveSection.value || showAttendanceSection.value,
);

const profileColClass = computed(() => {
  if (!showOverviewCard.value) return "col-xl-12";
  return "col-xl-4";
});

const overviewColClass = computed(() => {
  if (showLeaveSection.value) return "col-xl-5";
  return "col-xl-8";
});

// --- Year filter (shared across charts + cards) ---
const currentYear = new Date().getFullYear();
const years = [currentYear, currentYear - 1, currentYear - 2];
const selectedYear = ref(currentYear);

// --- Logged in user / employee info ---
const user = computed(() => authStore.user || authStore.currentUser || {});

const fullName = computed(() => {
  const first = user.value?.first_name || user.value?.name || "";
  const last = user.value?.last_name || "";
  return `${first} ${last}`.trim();
});

const email = computed(() => user.value?.email || "");
const phone = computed(
  () =>
    user.value?.phone || user.value?.mobile || user.value?.employee?.phone || ""
);

const designation = computed(
  () =>
    user.value?.employee?.designation?.name ||
    user.value?.designation_name ||
    user.value?.job_title ||
    ""
);

const department = computed(
  () =>
    user.value?.employee?.department?.name || user.value?.department_name || ""
);

const avatar = computed(() =>
  user.value ? resolveAvatarUrl(user.value?.employee?.avatar_url) : ""
);

// Try to derive manager / reporting officer if available
const managerName = computed(
  () => user.value?.manager_name || user.value?.employee?.manager_name || ""
);

// Join date: prefer employee company_doj, fallback to user.created_at
const joinedOn = computed(() => {
  const doj = user.value?.employee?.company_doj || user.value?.company_doj;
  const created = user.value?.created_at;
  const raw = doj || created;
  if (!raw) return "";
  // Normalize to YYYY-MM-DD only
  try {
    return raw.toString().slice(0, 10);
  } catch {
    return raw;
  }
});

// --- Leave summary (from EmployeeLeaveStore) ---
const totals = computed(() => {
  const s = leaveStore.summary || {};
  return s.totals || {};
});

const leaveTypes = computed(() => {
  const s = leaveStore.summary || {};
  return Array.isArray(s.types) ? s.types : [];
});

// Totals for right card
const totalLeaves = computed(() => totals.value.total_booked ?? 0);
const takenLeaves = computed(() => totals.value.total_taken ?? 0);
const requestedLeaves = computed(() => totals.value.total_applied ?? 0);
const remainingLeaves = computed(() => totals.value.total_remaining ?? 0);

// Sick leave from types (by slug/code)
const sickLeaveDays = computed(() => {
  const type =
    leaveTypes.value.find(
      (t) => t.slug === "sick-leave" || t.code?.toUpperCase() === "SICK"
    ) || null;
  return type?.booked ?? 0;
});

// --- Attendance summary (from AttendanceEmployeeStore) ---
const attendanceSummary = computed(
  () => attendanceStore.attendanceSummary || {}
);

// We'll map what we can. If backend doesn't have these fields, they safely fallback to 0.
const onTimeDays = computed(() => attendanceSummary.value.total_on_time ?? 0);

const lateDays = computed(() => attendanceSummary.value.total_late ?? 0);
const wfhDays = computed(() => attendanceSummary.value.total_remote ?? 0);
const absentDays = computed(() => attendanceSummary.value.total_absent ?? 0);
const lossOfPay = computed(
  () => attendanceSummary.value.total_loss_of_pay ?? 0
);

// Worked days from today's state (this month)
const workedDays = computed(() => attendanceStore.state?.workedDaysMonth ?? 0);

// Simple "better than X%" heuristic so it's not static
const betterThanPercent = computed(() => {
  const totalEmp = leaveStore.reportSummary?.total_employees ?? 100; // if you later pull from employeeStore.reportSummary
  if (!totalEmp || totalEmp <= 1) return 85;
  // assume this employee is around 75th percentile for now
  return 75;
});

// --- Donut chart for leave types ---
const leaveChartSeries = computed(() => {
  const series = leaveTypes.value.map((t) => t.booked || 0);
  // fallback to 1 so Apex doesn't break
  return series.length ? series : [1];
});

const leaveChartOptions = computed(() => {
  const labels = leaveTypes.value.length
    ? leaveTypes.value.map((t) => t.code || t.name)
    : ["No leave"];

  return {
    chart: {
      height: 255,
      type: "donut",
      toolbar: { show: false },
    },
    labels,
    dataLabels: {
      enabled: false,
    },
    colors: ["#F26522", "#FFC107", "#E70D0D", "#03C95A", "#0C4B5E"],
    legend: {
      show: false,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: { width: 200 },
          legend: { show: false },
        },
      },
    ],
  };
});

// --- Actions ---
function changeYear(year) {
  selectedYear.value = year;

  if (showLeaveSection.value) {
    leaveStore.fetchSummary({ year, silent: true });
  }
  if (showAttendanceSection.value) {
    attendanceStore.fetchMyAttendanceSummary({ year });
  }
}

// Initial load
onMounted(async () => {
  // Sequential on shared hosting: parallel API bursts exhaust MySQL max_user_connections.
  if (showLeaveSection.value) {
    await leaveStore.fetchSummary({ year: selectedYear.value, silent: true });
  }
  if (showAttendanceSection.value) {
    await attendanceStore.fetchToday();
    await attendanceStore.fetchMyAttendanceSummary({ year: selectedYear.value });
  }
});
</script>
